import { settings } from './settings';
import { tools } from './helpers/tools';
(function(hd, $) {
    hd.init = function(newSettings) {
        hd.tools = tools;
        hd.views = hd.views || {};

        settings.settings = $.extend(settings.settings, newSettings);
        settings.resources = $.extend(settings.resources, newSettings.resources);
    };
    // eslint-disable-next-line no-undef
})((window.hd = window.hd || {}), jQuery);

// Polyfills
if (!String.prototype.startsWith) {
    Object.defineProperty(String.prototype, 'startsWith', {
        value: function(search, pos) {
            pos = !pos || pos < 0 ? 0 : +pos;
            return this.substring(pos, pos + search.length) === search;
        },
    });
}

if (!String.prototype.endsWith) {
    String.prototype.endsWith = function(search, this_len) {
        if (this_len === undefined || this_len > this.length) {
            this_len = this.length;
        }
        return this.substring(this_len - search.length, this_len) === search;
    };
}

window.addEventListener('error', e => {
    // eslint-disable-next-line no-console
    console.dir(e.error);

    if (window.appInsights) {
        window.appInsights.trackException(e.error);
    }
});



// WEBPACK FOOTER //
// ./scripts/booking/main.js